<template>
  <div class="main" ref="main">
    <template v-if="hData.riskFactorList && hData.riskFactorList.length">
      <h1>
        当前共有
        <span>{{ hData ? hData.riskFactorList.length : "" }}</span>
        项风险因素
      </h1>
      <el-button
        style="float: right; margin-top: -30px"
        @click="$router.go(-1)"
        size="mini"
        >返回</el-button
      >
      <div class="col3">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="riskStatistical">
              <div class="riskStatisticalChart2-des">
                可控风险因素与不可控风险因素个数及占比
              </div>
              <div
                class="riskStatisticalChart2"
                ref="riskStatisticalChart2"
              ></div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="riskStatistical">
              <div class="riskStatisticalChart1-des">
                风险因素各维度个数及占比
              </div>
              <div
                class="riskStatisticalChart1"
                ref="riskStatisticalChart1"
              ></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="managerTitle">
        <el-row>
          <el-col :span="24">
            <el-select
              style="margin-left: 0px; width: 260px"
              @change="optionsChange"
              v-model="name1"
              filterable
              clearable
              placeholder="请选择风险因素"
            >
              <el-option
                v-for="(item, a) in options1"
                :key="a"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              style="margin-left: 10px; width: 260px"
              @change="optionsChange"
              v-model="name2"
              clearable
              filterable
              placeholder="请选择风险因素分类"
            >
              <el-option
                v-for="(item, b) in options2"
                :key="b"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <template v-if="riskFactor && riskFactor.length > 0">
        <div
          class="riskList"
          v-for="(items, index1) in riskFactor"
          :key="index1"
        >
          <div class="riskList-title">
            <span class="riskList-title-icon"></span>
            <span class="riskList-title-prompt">{{ items.title }}</span>
          </div>
          <div
            class="riskList-items"
            v-for="(item, index2) in items.groupRiskList"
            :key="index1 + '-' + index2"
          >
            <div
              class="riskList-item"
              @click="handleCheck(item, item1)"
              v-for="(item1, index3) in item.list"
              :key="index3"
              :class="{ highlight: !item1.selected }"
            >
              <span
                class="riskList-item-icon-back"
                :class="{
                  'riskList-item-icon-back-gray': !item1.hasControl,
                }"
              >
                <img
                  :class="{
                    'riskList-item-icon': true,
                    'riskList-item-icon-gray': !item1.hasControl,
                  }"
                  :src="item1.imgUrl"
                  alt="item1.riskFactorName"
                />
              </span>
              <span class="riskList-item-name">{{ item1.riskFactorName }}</span>
              <span class="riskList-item-statu">{{
                item1.hasControl ? "可控" : "不可控"
              }}</span>
              <div
                class="riskList-item-mark-inner"
                v-show="item1.selected"
              ></div>
              <div class="riskList-item-mark" v-show="item1.selected"></div>
            </div>
            <template v-if="item.list.length % 4 > 0">
              <div
                class="riskList-item-padding"
                v-for="(item, index2) in 4 - (item.list.length % 4)"
                :key="index1 + '-' + index2"
              ></div>
            </template>
            <div class="dialogDisease" v-show="item.selected">
              <p class="dialogDisease-desc">
                {{ selectedSubItem.riskFactorExplain }}
              </p>
              <div class="dialogDiseaseRisk">
                <p class="dialogDiseaseRisk-prompt">可能导致的疾病风险</p>
                <div
                  class="dialogDiseaseRisk-effect"
                  v-for="(item, index) in riskDegree"
                  :key="index"
                >
                  <div class="dialogDiseaseRisk-effect-left">
                    <div
                      class="bigEffect"
                      :style="{
                        color: judgeRiskLevel(item.title),
                        backgroundColor: judgeRiskLevelBg(item.title),
                      }"
                    >
                      {{ item.title }}
                    </div>
                    <!-- TODO 这是我注释掉的 -->
                    <!-- <div
                    class="bigIcon"
                    :style="{
                      backgroundColor: judgeRiskLevelBg(item.title),
                    }"
                  >
                    <div
                      class="bigIcon-center"
                      :style="{
                        backgroundColor: judgeRiskLevel(item.title),
                      }"
                    ></div>
                  </div> -->
                  </div>
                  <div class="dialogDiseaseRisk-effect-right">
                    <div
                      class="dialogDiseaseRisk-effect-right-item"
                      v-for="(item1, index1) in item.list"
                      :key="index1"
                    >
                      <span class="diseaseRiskName">{{
                        item1.diseaseName
                      }}</span>
                      <span class="diseaseRiskValue">{{
                        item1.rRValue
                          ? `患病风险${item1.rRValue}倍`
                          : "患病风险暂无"
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="suggest" ref="suggest">
                <img class="icon" src="@/assets/images/p_suggest.png" alt />
                <div class="empty"></div>
                <p class="des">
                  {{ selectedSubItem.riskFactorAdvise }}
                </p>
              </div>
            </div>
          </div>
        </div> </template
      ><template v-else>
        <div class="healthNonData">
          <img
            src="@/assets/images/hcalc2.png"
            class="healthNonDataImage"
            alt=""
          />
          <div class="healthNonDataText">暂无风险因素</div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="healthNonData">
        <img
          src="@/assets/images/hcalc2.png"
          class="healthNonDataImage"
          alt=""
        />
        <div class="healthNonDataText">暂无风险因素</div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getHRiskFactorIssue,
  getHealthUserAllDiseaseRisk,
  getPersionHValueDetail,
  getHealthHValue,
  getHRiskFactorList,
  getHealthRiskFactorList,
  getHealthRiskFactorListById,
  getAllRiskFactor,
} from "@/config/healthApi.js";

export default {
  components: {},
  name: "health-risk-factor",
  data() {
    return {
      riskFactorTypeList: [
        {
          riskFactorType: "生活方式",
          riskFactorList: [
            {
              diseaseInfluenceList: [
                {
                  diseaseName: "高血压",
                },
              ],
              riskFactorName: "饮酒",
              hasControl: true,
              riskFactorExplain:
                "饮酒是肝胆疾病的重要诱因。无节制的饮酒会使食物摄入量减少，以致发生多种营养素缺乏、急慢性酒精中毒、酒精性脂肪肝，严重时还会造成酒精性肝硬化；过量饮酒还会增加患高血压、中风、乳腺癌、消化道癌的危险。",
              riskFactorAdvise:
                '中国营养学会建议:成年男性一天饮用酒的酒精量不超过25g，即相当于啤酒750mL、葡萄酒25mL、38白酒75、52"高度白酒50g;成年女性不超过相当于啤酒450mL、葡萄酒150mL、38%白酒50g、52”高度白酒25g。饮',
            },
          ],
        },
      ],
      // riskFactorData:
      options1: [],
      name1: null,
      options2: [
        {
          value: "生活方式",
          label: "生活方式",
        },
        {
          value: "指标监测",
          label: "指标监测",
        },
        {
          value: "人口学信息",
          label: "人口学信息",
        },
        {
          value: "健康史",
          label: "健康史",
        },
        {
          value: "家族史",
          label: "家族史",
        },
        {
          value: "环境暴露史",
          label: "环境暴露史",
        },
      ],
      name2: null,
      selectedItem: null,
      selectedSubItem: {
        riskFactorExplain: null,
        riskFactorAdvise: null,
      },
      hData: {
        riskFactorList: [],
      },
      riskFactor: [],
      riskDegree: [],
      riskFactorData: [],
    };
  },
  created() {
    // this.riskFactorData = this.$store.state.healthDocUser.healthRiskFactorData;
    // this.hData = this.$store.state.healthDocUser.healthData;
  },
  mounted() {
    // this.getHRiskFactorIssue();
    this.getPersionHValueDetail();
    this.getAllRiskFactor();
    this.getHRiskFactorList();
  },
  methods: {
    async getAllRiskFactor() {
      const data = await getAllRiskFactor({
        userId: this.$store.state.healthDocUser.userId,
      });
      if (data.code == 1) {
        let allAiskFactor = data.data;
        allAiskFactor.forEach((item) => {
          this.options1.push({
            value: item,
            label: item,
          });
        });
      }
    },
    async getPersionHValueDetail() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthHValue({
          phoneNum: phone,
        });
      } else {
        data = await getPersionHValueDetail({
          userId: this.$store.state.healthDocUser.userId,
        });
      }
      if (data.code == 200) {
        let respondData = data.data;
        if (respondData.riskFactorList && respondData.riskFactorList.length) {
          let controlRiskList = [];
          let unControlRiskList = [];
          respondData.riskFactorList.forEach((item) => {
            if (item.hasControl) {
              controlRiskList.push(item);
            } else {
              unControlRiskList.push(item);
            }
          });
          respondData.controlRiskList = controlRiskList;
          respondData.unControlRiskList = unControlRiskList;

          respondData.riskFactorType = this.getRiskFactor(
            respondData.riskFactorList
          );
        }
        this.hData = respondData;
        this.$nextTick(() => {
          this.drawChart1();
          this.drawChart2();
        });
      }
    },
    async getHRiskFactorDetail(item) {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthRiskFactorListById({
          phoneNumber: phone,
          riskFactorId: item.riskFactorId,
          riskFactorName: item.riskFactorName,
          userId: this.$store.state.healthDocUser.userId,
        });
      } else {
        data = await getHRiskFactorList({
          userId: this.$store.state.healthDocUser.userId,
          riskFactorId: item.riskFactorId,
          riskFactorName: item.riskFactorName,
        });
      }
      if (data.code == 1) {
        let respondData = data.data;
        let riskDegree = [];
        let item1 = {
          title: "影响极大",
          list: [],
        };
        let item2 = {
          title: "影响较大",
          list: [],
        };
        let item3 = {
          title: "影响一般",
          list: [],
        };
        let item4 = {
          title: "影响较小",
          list: [],
        };

        respondData.forEach((item) => {
          if (item.diseaseInfluenceLevel == "影响极大") {
            item1.list.push(item);
          } else if (item.diseaseInfluenceLevel == "影响较大") {
            item2.list.push(item);
          } else if (item.diseaseInfluenceLevel == "影响一般") {
            item3.list.push(item);
          } else if (item.diseaseInfluenceLevel == "影响较小") {
            item4.list.push(item);
          }
        });

        if (item1.list.length) {
          riskDegree.push(item1);
        }
        if (item2.list.length) {
          riskDegree.push(item2);
        }
        if (item3.list.length) {
          riskDegree.push(item3);
        }
        if (item4.list.length) {
          riskDegree.push(item4);
        }

        this.riskDegree = riskDegree;
      }
    },
    optionsChange() {
      this.getHRiskFactorList();
    },
    async getHRiskFactorList() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthRiskFactorList({
          phoneNumber: phone,
          riskFactorName: this.name1,
          riskFactorType: this.name2,
        });
      } else {
        data = await getHRiskFactorList({
          userId: this.$store.state.healthDocUser.userId,
          riskFactorName: this.name1,
          riskFactorType: this.name2,
        });
      }

      if (data.code == 1) {
        let respondData = data.data;
        this.riskFactor = this.getRiskFactorGroup(respondData);
      }
    },
    getRiskFactor(respondData) {
      let riskFactor = [];

      let titles = [
        "生活方式",
        "指标监测",
        "人口学信息",
        "健康史",
        "家族史",
        "环境暴露史",
      ];

      titles.forEach((item, index) => {
        let item1 = {
          title: item,
          list: [],
          groupRiskList: [],
        };
        riskFactor.push(item1);
      });

      respondData.forEach((item, index) => {
        item.selected = false;
        if (item.riskFactorType == "生活方式") {
          riskFactor[0].list.push(item);
        } else if (item.riskFactorType == "指标监测") {
          riskFactor[1].list.push(item);
        } else if (item.riskFactorType == "人口学信息") {
          riskFactor[2].list.push(item);
        } else if (item.riskFactorType == "健康史") {
          riskFactor[3].list.push(item);
        } else if (item.riskFactorType == "家族史") {
          riskFactor[4].list.push(item);
        } else if (item.riskFactorType == "环境暴露史") {
          riskFactor[5].list.push(item);
        }
      });
      return riskFactor;
    },
    getRiskFactorGroup(respondData) {
      let riskFactor = [];

      let titles = [
        "生活方式",
        "指标监测",
        "人口学信息",
        "健康史",
        "家族史",
        "环境暴露史",
      ];

      titles.forEach((item, index) => {
        let item1 = {
          title: item,
          list: [],
          groupRiskList: [],
        };
        riskFactor.push(item1);
      });

      respondData.forEach((item, index) => {
        item.selected = false;
        if (item.riskFactorType == "生活方式") {
          let cou = 0;
          riskFactor[0].list.find((a) => {
            if (a.riskFactorName == item.riskFactorName) {
              cou++;
            }
          });
          if (cou == 0) {
            try {
              item.imgUrl = require("@/assets/images/risk/" +
                item.riskFactorName +
                "@2x.png");
            } catch (error) {
              item.imgUrl = require("@/assets/images/risk/default.png");
            }
            riskFactor[0].list.push(item);
          }
        } else if (item.riskFactorType == "指标监测") {
          let cou = 0;
          riskFactor[1].list.find((a) => {
            if (a.riskFactorName == item.riskFactorName) {
              cou++;
            }
          });
          if (cou == 0) {
            try {
              item.imgUrl = require("@/assets/images/risk/" +
                item.riskFactorName +
                "@2x.png");
            } catch (error) {
              item.imgUrl = require("@/assets/images/risk/default.png");
            }
            riskFactor[1].list.push(item);
          }
        } else if (item.riskFactorType == "人口学信息") {
          let cou = 0;
          riskFactor[2].list.find((a) => {
            if (a.riskFactorName == item.riskFactorName) {
              cou++;
            }
          });
          if (cou == 0) {
            try {
              item.imgUrl = require("@/assets/images/risk/" +
                item.riskFactorName +
                "@2x.png");
            } catch (error) {
              item.imgUrl = require("@/assets/images/risk/default.png");
            }
            riskFactor[2].list.push(item);
          }
        } else if (item.riskFactorType == "健康史") {
          let cou = 0;
          riskFactor[3].list.find((a) => {
            if (a.riskFactorName == item.riskFactorName) {
              cou++;
            }
          });
          if (cou == 0) {
            try {
              item.imgUrl = require("@/assets/images/risk/" +
                item.riskFactorName +
                "@2x.png");
            } catch (error) {
              item.imgUrl = require("@/assets/images/risk/default.png");
            }
            riskFactor[3].list.push(item);
          }
        } else if (item.riskFactorType == "家族史") {
          let cou = 0;
          riskFactor[4].list.find((a) => {
            if (a.riskFactorName == item.riskFactorName) {
              cou++;
            }
          });
          if (cou == 0) {
            try {
              item.imgUrl = require("@/assets/images/risk/" +
                item.riskFactorName +
                "@2x.png");
            } catch (error) {
              item.imgUrl = require("@/assets/images/risk/default.png");
            }
            riskFactor[4].list.push(item);
          }
        } else if (item.riskFactorType == "环境暴露史") {
          let cou = 0;
          riskFactor[5].list.find((a) => {
            if (a.riskFactorName == item.riskFactorName) {
              cou++;
            }
          });
          if (cou == 0) {
            try {
              item.imgUrl = require("@/assets/images/risk/" +
                item.riskFactorName +
                "@2x.png");
            } catch (error) {
              item.imgUrl = require("@/assets/images/risk/default.png");
            }
            riskFactor[5].list.push(item);
          }
        }
      });
      for (let i = riskFactor.length - 1; i >= 0; i--) {
        let item = riskFactor[i];
        if (item.list.length) {
          let groupRiskList = [];
          while (item.list.length) {
            let item1 = {};
            let list = null;
            if (item.list.length >= 4) {
              list = item.list.splice(0, 4);
            } else {
              list = item.list.splice(0, item.list.length);
            }
            item1.selected = false;
            item1.list = list;
            groupRiskList.push(item1);
          }
          item.groupRiskList = groupRiskList;
        } else {
          riskFactor.splice(i, 1);
        }
      }
      return riskFactor;
    },
    drawChart1() {
      if (!this.hData.riskFactorType || !this.hData.riskFactorType.length) {
        return;
      }
      let bgColor = "#fff";
      // let title = "总量";
      // let count = 234444;
      let colors = [
        "#5E81F4",
        "#FF808B",
        "#8A9DF1",
        "#F4BE5E",
        "#F1A28A",
        "#8BF1B9",
      ];
      let echartData = [];
      this.hData.riskFactorType.forEach((item, index) => {
        if (item.list.length) {
          let obj = {
            name: item.title,
            value: item.list.length,
          };
          echartData.push(obj);
        }
      });

      let allCount = echartData.length;
      echartData.forEach((item, index) => {
        item.percent = item.value / allCount;
      });

      let legendData = [];
      for (var j = 0; j < echartData.length; j++) {
        var data = {
          name: echartData[j].name,
          icon: "circle",
          textStyle: {
            fontSize: 18,
            color: colors[j],
          },
        };
        legendData.push(data);
      }
      let objData = this.array2obj(echartData, "name");
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart1 = this.$refs.riskStatisticalChart1;
      var myChart = this.$echarts.init(riskStatisticalChart1);

      let option = {
        backgroundColor: bgColor,
        color: colors,
        legend: {
          orient: "vertical",
          top: "center",
          left: "60%",
          itemGap: 15,
          data: legendData,
          formatter: function (name) {
            return `{title|${name}}{value|${objData[name].value}个}`;
          },
          textStyle: {
            rich: {
              title: {
                color: "#333333",
                fontSize: 16,
                width: 120,
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              value: {
                color: "#333333",
                fontSize: 16,
                width: 20,
                align: "right",
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              // unit: {
              //     color: '#333333',
              //     fontSize: 16,
              //     // fontWeight: 600,
              //     // fontFamily: 'HuaKang',
              //     padding: [0, 0, 0, 0]
              // },
            },
          },
        },
        series: [
          {
            type: "pie",
            radius: ["0%", "48%"],
            center: ["30%", "50%"],
            data: echartData,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderColor: bgColor,
                borderWidth: 0,
              },
            },
            // labelLine: {
            //   show: false,
            // },
            label: {
              // position: 'inside',
              formatter: function (params) {
                // return `{percent|${params.percent}}{unit|%}`
                return `${params.percent}%`;
              },
              // {unit|件}{percent|${objData[name].percent}}{unit|%}
              // formatter: params => {
              //     return (
              //         '{percent|' + objData[params.name].percent + '}{unit|%}'
              //     );
              // },
              rich: {
                percent: {
                  fontSize: 14,
                  color: "#fff",
                },
                unit: {
                  fontSize: 14,
                  color: "#fff",
                },
              },
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    drawChart2() {
      if (!this.hData.riskFactorList.length) {
        return;
      }
      let bgColor = "#fff";
      // let title = '总量';
      // let count = 234444;
      let colors = ["#FFAC21", "#678EFF"];
      let echartData = [
        {
          name: "可控风险因素",
          value: `${this.hData.controlRiskList.length}`,
          percent: `${
            this.hData.controlRiskList.length / this.hData.riskFactorList.length
          }`,
          label: "90",
        },
        {
          name: "不可控风险因素",
          value: `${this.hData.unControlRiskList.length}`,
          percent: `${
            this.hData.unControlRiskList.length /
            this.hData.riskFactorList.length
          }`,
          label: "90",
        },
      ];

      let legendData = [];
      for (var j = 0; j < echartData.length; j++) {
        var data = {
          name: echartData[j].name,
          icon: "rect",
          value: echartData[j].value,
          percent: echartData[j].percent,
          label: echartData[j].label,
          textStyle: {
            fontSize: 18,
            color: colors[j],
          },
        };
        legendData.push(data);
      }
      let objData = this.array2obj(echartData, "name");
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart2 = this.$refs.riskStatisticalChart2;
      var myChart = this.$echarts.init(riskStatisticalChart2);

      let option = {
        backgroundColor: bgColor,
        color: colors,
        // title: [{
        //     text: '{name|' + title + '}\n{val|' + count + '}',
        //     top: 'center',
        //     left: '29%',
        //     textAlign: 'center',
        //     textStyle: {
        //         rich: {
        //             name: {
        //                 fontSize: 14,
        //                 fontWeight: 'normal',
        //                 color: '#666666',
        //                 padding: [10, 0]
        //             },
        //             val: {
        //                 fontSize: 14,
        //                 fontWeight: 'bold',
        //                 color: '#333333',
        //             }
        //         }
        //     }
        // }],
        legend: {
          // orient: 'vertical',
          bottom: "20",
          left: "center",
          itemGap: 10,
          data: legendData,
          formatter: function (name) {
            return `{title|${name}}{value|${objData[name].value}个}`;
          },
          textStyle: {
            rich: {
              title: {
                color: "#333333",
                fontSize: 16,
                width: 140,
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              value: {
                color: "#333333",
                fontSize: 16,
                width: 20,
                align: "right",
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              //     unit: {
              //         color: '#333333',
              //         fontSize: 16,
              //         // fontWeight: 600,
              //         // fontFamily: 'HuaKang',
              //         padding: [0, 5, 0, 0]
              //     },
            },
          },
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "48%"],
            center: ["50%", "40%"],
            data: echartData,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderColor: bgColor,
                borderWidth: 0,
              },
            },
            // labelLine: {
            //     show: false,
            // },
            label: {
              // position: 'inside',
              formatter: function (params) {
                // return `{percent|${params.percent}}{unit|%}`
                return `${params.percent}%`;
              },
              // {unit|件}{percent|${objData[name].percent}}{unit|%}
              // formatter: params => {
              //     return (
              //         '{percent|' + objData[params.name].percent + '}{unit|%}'
              //     );
              // },
              // rich: {
              //     percent: {
              //         fontSize: 14,
              //         color: 'red'
              //     },
              //     unit: {
              //         fontSize: 14,
              //         color: 'blue'
              //     }
              // }
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    array2obj(array, key) {
      var resObj = {};
      for (var i = 0; i < array.length; i++) {
        resObj[array[i][key]] = array[i];
      }
      return resObj;
    },
    handleCheck(item, subItem) {
      if (!subItem.hasControl) {
        return;
      }
      if (this.selectedItem == item && this.selectedSubItem == subItem) {
        item.selected = !item.selected;
        subItem.selected = !subItem.selected;

        this.selectedItem = item;
        this.selectedSubItem = subItem;
        return;
      }

      if (this.selectedItem && this.selectedSubItem) {
        if (this.selectedItem.selected) {
          this.selectedItem.selected = !this.selectedItem.selected;
        }
        if (this.selectedSubItem.selected) {
          this.selectedSubItem.selected = !this.selectedSubItem.selected;
        }
      }

      this.getHRiskFactorDetail(subItem);

      item.selected = !item.selected;
      subItem.selected = !subItem.selected;

      this.selectedItem = item;
      this.selectedSubItem = subItem;
    },
    judgeRiskLevel(statu) {
      if (statu == "影响极大") {
        return "#E02020";
      } else if (statu == "影响较大") {
        return "#E02020";
      } else if (statu == "影响一般") {
        return "#FA6400";
      } else if (statu == "影响较小") {
        return "#FF8C00";
      }
    },
    judgeRiskLevelBg(statu) {
      if (statu == "影响极大") {
        return "rgba(224,32,32,0.1)";
      } else if (statu == "影响较大") {
        return "rgba(224,32,32,0.1)";
      } else if (statu == "影响一般") {
        return "rgba(250,100,0,0.1)";
      } else if (statu == "影响较小") {
        return "rgba(255,140,0,0.1)";
      }
    },
    // async getHRiskFactorIssue() {
    //   const data = await getHRiskFactorIssue({
    //     userId: this.$store.state.healthDocUser.userId,
    //   });
    //   if (data.code == 200) {
    //     let riskFactorData = data.data;
    //     this.riskFactorData = riskFactorData;
    //     this.$nextTick(() => {
    //       this.drawChart1(riskFactorData);
    //     });
    //   }
    // },
  },
};
</script>

<style scoped>
.main {
  min-width: 1080px;
  /* padding: 100px 0; */
  overflow: scroll;
  position: relative;
  height: 100%;
  overflow-x: hidden;
}

h1 {
  padding-top: 20px;
  color: #333333;
  font-size: 16px;
}

h1 span {
  color: #3381ff;
}

.col3 {
  margin-top: 18px;
}

.riskStatistical {
  overflow: hidden;
  margin-top: 10px;
  background-color: #fff;
}

.riskStatisticalChart1-des {
  padding: 16px 18px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.19px;
  line-height: 16px;
}

.riskStatisticalChart1 {
  width: 100%;
  height: 300px;
}

.riskStatisticalChart2-des {
  padding: 16px 18px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.19px;
  line-height: 16px;
}

.riskStatisticalChart2 {
  width: 100%;
  height: 300px;
}

.managerTitle {
  margin-top: 20px;
}

.riskList {
  overflow: hidden;
  margin-top: 20px;
  background-color: #fff;
  /* border-radius: 0; */
}

.riskList:last-child {
  margin-bottom: 20px;
}

.riskList-title {
  margin-top: 16px;
  height: 16px;
  position: relative;
}
.riskList-title-icon {
  background-color: #0062ff;
  display: inline-block;
  width: 4px;
  height: 14px;
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  left: 18px;
}
.riskList-title-prompt {
  margin-left: 0px;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.22px;
  line-height: 18px;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 30px;
}

.riskList-items {
  margin: 0px 20px 20px 20px;
  /* background-color: tomato; */
  /* width: 100%; */
  /* height: 600px;  */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* align-items:center; */
  /* align-items:flex-start; */
  flex-wrap: wrap;
  align-content: flex-start;
}

.riskList-item-padding {
  flex: 0 1 23%;
  /* width: 200px; */
  height: 112px;
}

/* .riskList-items::after {
	  content: "";
	  display: block;
	  flex: 0 1 21%;
	} */

.highlight {
  opacity: 0.5;
}

.riskList-item {
  /* opacity: 1.0; */
  flex: 0 1 23%;
  /* width: 200px; */
  height: 112px;
  text-align: center;
  /* line-height: 200px; */
  font-size: 12px;
  /* margin: 20px 0; */
  position: relative;

  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(21, 34, 50, 0.12);
  border-radius: 6px;
}

.riskList-item-icon-back {
  display: inline-block;
  width: 49px;
  height: 49px;
  background-image: linear-gradient(
    180deg,
    rgba(0, 122, 255, 0.7) 0%,
    #007aff 100%
  );
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.07);
  border-radius: 24.5px;
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translateY(-50%);
}

.riskList-item-icon-back-gray {
  background-image: linear-gradient(
    180deg,
    rgba(153, 153, 153, 0.7) 0%,
    rgba(153, 153, 153, 1) 100%
  );
}
/* 'background-image': 'linear-gradient(180deg, rgba(153,153,153,0.7) 0%, rgba(153,153,153,1) 100%)' */
/* #D7DBEC" */

.riskList-item-icon {
  position: absolute;
  width: 32px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.riskList-item-icon-gray {
  filter: grayscale(100%);
}

.riskList-item-name {
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #333333;
  position: absolute;
  top: 35%;
  left: 40%;
  transform: translateY(-50%);
}

.riskList-item-statu {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #067dff;
  letter-spacing: 0.17px;
  line-height: 14px;
  position: absolute;
  top: 65%;
  left: 40%;
  transform: translateY(-50%);
}

.riskList-item-mark {
  /* margin-left: -4px; */
  /* border: 4px solid transparent; */

  position: absolute;
  bottom: -20px;
  left: 50%;
  width: 0;
  height: 0;
  border-color: transparent transparent #dddddd transparent;
  border-style: solid;
  border-width: 0px 20px 15px 20px;
  z-index: 2;
  transform: translateX(-50%);
}

.riskList-item-mark-inner {
  position: absolute;
  bottom: -21px;
  left: 50%;
  width: 0;
  height: 0;
  border-color: transparent transparent #f5f5f5 transparent;
  border-style: solid;
  border-width: 0px 20px 15px 20px;
  z-index: 3;
  transform: translateX(-50%);
}

/* 
	    position: absolute;
	    display: block;
	    width: 0;
	    height: 0;
	    border-color: transparent;
	    border-style: solid; 
	    
	    
	    border-width: 6px;
	    -webkit-filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
	    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));    


	    top: 50%;
	    left: -6px;
	    margin-bottom: 3px;
	    border-right-color: #EBEEF5;
	    border-left-width: 0;

	    */

.dialogDisease {
  /* padding: 20px; */
  width: 100%;
  margin-top: 20px;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px;
}

/* .dialogDisease-title {
	}

	.dialogDisease-title-name {
	  font-size: 16px;
	}

	.dialogDisease-title-control {
	  font-size: 14px;
	  color: blue;
	} */

.dialogDisease-desc {
  /* margin-top: 5px; */
  background-color: rgba(0, 0, 0, 0.03);
  padding: 16px;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #999999;
  letter-spacing: 0.22px;
  text-align: justify;
}

.dialogDiseaseRisk {
  margin: 16px 12px;
  /* padding: 10px; */
  /* border-top: lightgray 1px solid;
	  border-bottom: lightgray 1px solid; */
}

.dialogDiseaseRisk-prompt {
  margin: 20px 0px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.19px;
  line-height: 18px;
}

.dialogDiseaseRisk-effect {
  display: flex;
  margin: 20px 0px;
}

.dialogDiseaseRisk-effect-left {
  flex: 0 1 130px;
  position: relative;
}

.bigIcon {
  /* display: inline-block; */
  /* box-sizing: content-box; */
  width: 16px;
  height: 16px;
  background-color: rgba(224, 32, 32, 0.3);
  border-radius: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
}

.bigIcon-center {
  width: 10px;
  height: 10px;
  background-color: #e02020;
  border-radius: 5px;
  margin: 3px;
}

.generalIcon {
  /* display: inline-block; */
  /* box-sizing: content-box; */
  width: 16px;
  height: 16px;
  background-color: rgba(250, 100, 0, 0.3);
  border-radius: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
}

.generalIcon-center {
  width: 10px;
  height: 10px;
  background-color: #fa6400;
  border-radius: 5px;
  margin: 3px;
}

.smallIcon {
  /* display: inline-block; */
  /* box-sizing: content-box; */
  width: 16px;
  height: 16px;
  background-color: rgba(255, 140, 0, 0.3);
  border-radius: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
}

.smallIcon-center {
  width: 10px;
  height: 10px;
  background-color: #ff8c00;
  border-radius: 5px;
  margin: 3px;
}

.bigEffect {
  display: inline-block;
  border-radius: 2px;
  background-color: rgba(224, 32, 32, 0.1);
  padding: 5px;
  margin: 5px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  line-height: 16px;
  /* height: 16px; */
  text-align: center;
  color: #e02020;
  letter-spacing: 0;
  position: absolute;
  top: 10%;
  left: 0;
  /* transform: translate(0,-50%); */
}

.generalEffect {
  display: inline-block;
  border-radius: 2px;
  background-color: rgba(250, 100, 0, 0.1);
  padding: 5px;
  margin: 5px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  text-align: center;
  color: #fa6400;
  letter-spacing: 0;
  position: absolute;
  top: 10%;
  left: 0;
}

.smallEffect {
  display: inline-block;
  border-radius: 2px;
  background-color: rgba(255, 140, 0, 0.1);
  padding: 5px;
  margin: 5px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  text-align: center;
  color: #ff8c00;
  letter-spacing: 0;
  position: absolute;
  top: 10%;
  left: 0;
}

.dialogDiseaseRisk-effect-right {
  flex: 0 1 100%;
}

.dialogDiseaseRisk-effect-right-item {
  display: inline-block;
  background: rgba(221, 221, 221, 0.2);
  border: 1px solid #dddddd;
  border-radius: 2px;
  padding: 5px;
  margin: 5px;
}

.dialogDiseaseRisk-effect-right-item .diseaseRiskName {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #047cff;
  letter-spacing: 0.17px;
  line-height: 14px;
}

.dialogDiseaseRisk-effect-right-item .diseaseRiskValue {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.17px;
  line-height: 14px;
}

.suggest {
  background: #fefffe;
  margin: 34px 24px 24px 24px;
  padding: 16px;
  background-color: rgba(17, 130, 240, 0.1);
  border-radius: 4px;
  position: relative;
}
.suggest .icon {
  width: 72px;
  position: absolute;
  left: -10px;
  top: -25px;
}
.suggest .empty {
  width: 72px;
  height: 14px;
  float: left;
}
.suggest .des {
  font-size: 14px;
  color: #666666;
  text-align: justify;
}

.healthNonData {
  position: relative;
  height: 600px;
}

.healthNonDataImage {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.healthNonDataText {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #999999;
  text-align: center;
  position: absolute;
  left: 0px;
  bottom: 100px;
}
</style>
